import React, { Component } from 'react';
import NowPlaying from './NowPlaying';
import './App.css';
import groove from './images/southern-groove.png';
import smooth from './images/southern-smooth.png';
import sotherlyhotels from './images/logo.png';
import customchannels from './images/customchannels.png';

class App extends Component {

  constructor(){
    super();
    this.state = {
      channel: {
        name: 'Southern Groove',
        stream_url: 'http://stream.customchannels.net/sotherlys_southern_groove_96.mp3',
        id: 688
      }
    }
  }

  setSmooth(){
    this.setState({
      channel: {
        name: 'Southern Smooth',
        stream_url: 'http://stream.customchannels.net/sotherlys_southern_smooth_96.mp3',
        id: 687
      }
    });
  }

  setGroove(){
    this.setState({
      channel: {
        name: 'Southern Groove',
        stream_url: 'http://stream.customchannels.net/sotherlys_southern_groove_96.mp3',
        id: 688
      }
    });
  }

  render() {
    return (
      <div className="App">
          <div className="RadioLogo"></div>
          <NowPlaying channel={ this.state.channel } />
          <div className="Info">
            <h1>Pick a mix</h1>
            <p>Whether you're having a night out with friends or simply admiring the scenery, enjoy the perfect selection of hand-picked tunes by southern artists. Select a station below to start listening. </p>
          </div>
          <div className="Channels">
            <div className="Groove">
              <img onClick={ () => this.setGroove() } src={ groove } alt="Southern Groove" />
              <p>A mix of classic upbeat tunes featuring southern artists like Creedence Clearwater Revival &amp; James Brown.</p>
            </div>
            <div className="Smooth">
              <img onClick={ () => this.setSmooth() } src={ smooth } alt="Southern Smooth" />
              <p>Taking you from day to night with the perfect collection of mid-tempo beats to soothe your mind &amp; unwind.</p>
            </div>
          </div>
          <div className="Logos">
            <a href="http://sotherlyhotels.com/" rel="noopener noreferrer" target="_blank">
              <img src={ sotherlyhotels } alt="Sotherly Hotels" />
            </a>
            <br />
            <a href="https://www.customchannels.net" rel="noopener noreferrer" target="_blank">
              <img src={ customchannels } alt="Custom Channels" />
            </a>
          </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js